import React from 'react';
import { motion } from 'framer-motion';
import StarIcon from '@mui/icons-material/Star';
export function Stats() {
  const stats = [{
    value: '+500',
    label: 'creativas confían'
  }, {
    value: '2',
    label: 'Tomos completos'
  }, {
    value: '4',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    icon: <StarIcon className="text-brand-gold ml-1" fontSize="small" data-id="element-312" />
  }];
  return <section className="bg-brand-choco-deep text-brand-cream py-6 border-y border-brand-gold/20" data-id="element-313">
      <div className="max-w-7xl mx-auto px-6" data-id="element-314">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-brand-gold/10" data-id="element-315">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`flex flex-col items-center justify-center ${index % 2 !== 0 ? 'border-l border-brand-gold/10 md:border-none' : 'border-none'}`} data-id="element-316">
              <div className="text-3xl md:text-4xl font-serif font-bold text-brand-gold flex items-center justify-center" data-id="element-317">
                {stat.value}
                {stat.icon}
              </div>
              <div className="text-sm md:text-base mt-2 text-brand-cream/80 uppercase tracking-wider font-medium" data-id="element-318">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}